export const BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT = 'aud_mobile_bx585_saved_search_favorites_merge';

export const EXPERIMENTS = [BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT];
